import React, { useState,  useContext, useCallback, useMemo } from "react";
import { Button, ToggleSwitch, Input } from "@abb/abb-common-ux-react";
import { RootContext } from "../../../../contexts/root-context";
import axios from "axios";
import "./objective-fun.css";
import { EMCORE_BASE_API_URL } from "../../../../strings";
import microGridAPICall from "../../api";
import defaultJson from "./objectiveDefaults.json";

const ObjectiveFunction = () => {
  const { setisnotify } = useContext(RootContext);

  // Default values from imported JSON
  const defaultData = useMemo(() => defaultJson, []);

  // State management for all inputs
  const [state, setState] = useState({
    peakShavingEnabled: defaultData.defaultWeights.peak_shaving.realize,
    peakShavingWeight: defaultData.defaultWeights.peak_shaving.weighting,
    energyArbitrageEnabled: defaultData.defaultWeights.energy_arbitrage.realize,
    energyArbitrageWeight: defaultData.defaultWeights.energy_arbitrage.weighting,
    loadSheddingEnabled: defaultData.defaultWeights.load_shedding.realize,
    loadSheddingWeight: defaultData.defaultWeights.load_shedding.weighting,
    profileSmoothingEnabled: defaultData.defaultWeights.profile_smoothing.realize,
    profileSmoothingWeight: defaultData.defaultWeights.profile_smoothing.weighting,
    previousHighestPeakKW: defaultData.defaultContext.previous_highest_peak_kW,
    priceHighestPeakCurrency: defaultData.defaultContext.price_highest_peak_currency_per_kW_billing_period,
    endCurrentBillingPeriod: defaultData.defaultContext.end_of_current_billing_period,
    includeEnergyTracking: defaultData.defaultConfiguration.include_energy_tracking,
  });

  // Update state dynamically
  const handleInputChange = useCallback((key, value) => {
    setState((prevState) => ({ ...prevState, [key]: value }));
  }, []);

  const handleSaveUserInfo = useCallback(async () => {
    setisnotify("");
    const payload = {
      objectives: {
        peak_shaving: { realize: state.peakShavingEnabled, weighting: state.peakShavingWeight },
        energy_arbitrage: { realize: state.energyArbitrageEnabled, weighting: state.energyArbitrageWeight },
        load_shedding: { realize: state.loadSheddingEnabled, weighting: state.loadSheddingWeight },
        profile_smoothing: { realize: state.profileSmoothingEnabled, weighting: state.profileSmoothingWeight },
      },
      context: {
        previous_highest_peak_kW: state.previousHighestPeakKW,
        price_highest_peak_currency_per_kW_billing_period: state.priceHighestPeakCurrency,
        end_of_current_billing_period: state.endCurrentBillingPeriod,
      },
      configuration: { include_energy_tracking: state.includeEnergyTracking },
    };

    try {
      const response = await microGridAPICall("post", `${EMCORE_BASE_API_URL}generate-charts`, payload, {});
      console.log("Data saved successfully:", response);
      const dashboardS3Url = response.s3url;
      localStorage.setItem("dashboard-charts-s3-url", dashboardS3Url);
      setisnotify("objfuntions");
    } catch (error) {
      console.error("There was an error saving the data!", error);
    }
  }, [state, setisnotify]);

  const renderInputRow = useCallback((label, enabledKey, weightKey) => (
    <>
      <tr><td><b>{label}</b></td></tr>
      <tr>
        <td>
          <ToggleSwitch
            label={state[enabledKey] ? "Enable" : "Disable"}
            value={state[enabledKey]}
            onChange={(value) => handleInputChange(enabledKey, value)}
          />
        </td>
      </tr>
      <tr>
        <td>
          <Input
            label="Weightage"
            value={state[weightKey]}
            placeholder="Enter weighting"
            onValueChange={(value) => handleInputChange(weightKey, value)}
          />
        </td>
      </tr>
    </>
  ), [state, handleInputChange]);

  return (
    <div className="edit-user-container">
      <table id="edit-user-table">
        {renderInputRow("Peak Shaving", "peakShavingEnabled", "peakShavingWeight")}
        {renderInputRow("Energy Arbitrage", "energyArbitrageEnabled", "energyArbitrageWeight")}
        {renderInputRow("Load Shedding", "loadSheddingEnabled", "loadSheddingWeight")}
        {renderInputRow("Profile Smoothing", "profileSmoothingEnabled", "profileSmoothingWeight")}

        {/* Context Section */}
        <tr><td><b>Context</b></td></tr>
        <tr>
          <td>
            <Input
              label="Previous Highest Peak kW"
              value={state.previousHighestPeakKW}
              placeholder="Enter kW"
              onValueChange={(value) => handleInputChange("previousHighestPeakKW", value)}
            />
          </td>
        </tr>
        <tr>
          <td>
            <Input
              label="Highest Peak Price per MW (€)"
              value={state.priceHighestPeakCurrency}
              placeholder="Enter price"
              onValueChange={(value) => handleInputChange("priceHighestPeakCurrency", value)}
            />
          </td>
        </tr>
        <tr>
          <td>
            <Input
              label="End of Current Billing Period"
              value={state.endCurrentBillingPeriod}
              placeholder="Enter billing period"
              onValueChange={(value) => handleInputChange("endCurrentBillingPeriod", value)}
            />
          </td>
        </tr>

        {/* Configuration Section */}
        <tr>
          <td>
            <span>Include Energy Tracking</span>
            <ToggleSwitch
              label={state.includeEnergyTracking ? "Enable" : "Disable"}
              value={state.includeEnergyTracking}
              onChange={(value) => handleInputChange("includeEnergyTracking", value)}
            />
          </td>
        </tr>

        {/* Save Button */}
        <tr>
          <td>
            <Button
              text="Run"
              shape="pill"
              sizeClass="small"
              type="primary-black"
              onClick={handleSaveUserInfo}
            />
            <Button text="Cancel" shape="pill" sizeClass="small" />
          </td>
        </tr>
      </table>
    </div>
  );
};

export default ObjectiveFunction;